<div class="draggable-templates-container">
  <div
    class="inner"
    [ngClass]="{ heightSuperuser: isSuperUser }"
  >
    <div class="content">
      <div class="top">
        <div class="title">
          {{ 'CALENDAR.TEMPLATES' | translate }}
        </div>
        <div class="subtitle">
          <span [innerHTML]="'CALENDAR.TEMPLATE.DRAG_TEMPLATE' | translate"></span>
        </div>
        <div class="subtext">
          {{ 'CALENDAR.TEMPLATE.SUBTEXT' | translate }}
        </div>

        <a
          class="btn-cancel clear_selection"
          (click)="selectTemplate.emit(null)"
          *ngIf="selectedTemplate"
          >{{ 'CALENDAR.TEMPLATE.CLEAR_SELECTION' | translate }}</a
        >
      </div>
      <div
        class="displayCustomer"
        *ngIf="isSuperUser"
      >
        <app-calendar-legend-customer [customer]="selectedCustomer"></app-calendar-legend-customer>
      </div>
      <div
        class="search-input-wrapper"
        style="margin-bottom: 10px; position: relative"
      >
        <i class="fa fa-search search-icon"></i>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'CALENDAR.TEMPLATE.SEARCH_PLACEHOLDER' | translate }}"
          [(ngModel)]="templateSearch"
          style="padding-left: 30px; padding-right: 30px"
        />
        <i
          class="fa fa-times clear-icon"
          *ngIf="templateSearch"
          (click)="templateSearch = ''"
        ></i>
      </div>
      <div
        class="templates"
        [ngStyle]="{ 'height.px': height }"
        *ngIf="(canViewTemplate && isSuperUser) || !isSuperUser"
        cdkDropList
      >
        <!--        [dragula]="'templates-bag'"-->
        <div
          *ngFor="let template of templates | templateNameFilter : templateSearch"
          class="template"
          [attr.data-id]="template.id"
          [attr.data-name]="'templates'"
          (click)="selectTemplate.emit(template)"
          cdkDrag
          [cdkDragData]="template"
          (cdkDragDropped)="dropped($event)"
          [cdkDragDisabled]="template.id !== selectedTemplate?.id"
        >
          <div
            *cdkDragPreview
            class="cdk-drag-preview"
          >
            {{ template.name }}
          </div>
          <div
            class="drag-placeholder"
            *cdkDragPlaceholder
          >
            &nbsp;
          </div>

          <div
            class="content"
            [ngClass]="{ selected: template.id === selectedTemplate?.id, grayed: selectedTemplate && template.id !== selectedTemplate?.id }"
          >
            <div class="content-body">
              <span
                class="drag_icon"
                *ngIf="!deliveryDaysRequesting && selectedTemplate && template.id === selectedTemplate.id"
              >
                <i class="fa fa-arrows"></i>
              </span>
              <span *ngIf="(deliveryDaysRequesting && selectedTemplate && template.id === selectedTemplate.id) || editing === template.id">
                <i class="fa fa-spinner fa-pulse fa-fw"></i>
              </span>
              <div class="text">
                <span class="bold">{{ template.name }}</span>
              </div>
              <div
                class="action_buttons"
                *ngIf="!(editing === template.id)"
              >
                <span
                  class="edit_icon"
                  (click)="$event.stopPropagation(); editTemplate.emit(template.id)"
                >
                  <i
                    class="fa fa-pencil"
                    *ngIf="!deleting"
                  ></i>
                  <i
                    class="fa fa-spinner fa-pulse fa-fw"
                    *ngIf="deleting"
                  ></i>
                </span>
                <span
                  class="trash_icon"
                  (click)="$event.stopPropagation(); deleteTemplate.emit(template.id)"
                >
                  <i
                    class="fa fa-trash"
                    *ngIf="!deleting"
                  ></i>
                  <i
                    class="fa fa-spinner fa-pulse fa-fw"
                    *ngIf="deleting"
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="hr"
      *ngIf="showBack"
    ></div>

    <div
      class="bottom"
      *ngIf="showBack"
    >
      <eps-button
        [label]="'CALENDAR.' + type + '.BACK'"
        (buttonClick)="goBack.emit()"
      ></eps-button>
      <eps-button
        label="CALENDAR.CREATE_TEMPLATE"
        (buttonClick)="createTemplate.emit()"
        *ngIf="authorization.ORDER.CREATE"
      ></eps-button>
    </div>
  </div>
</div>
